/**
 * @param bandwidth in gb where 0 means unlimited
 * @param isYearly if provided it shows a term eg, `/month` or `/year`. If not provided no term is shown.
 */
export default function formatBandwidth(bandwidth?: number) {
  const gbString =
    bandwidth === 0
      ? "∞ GB bandwidth"
      : `${bandwidth?.toLocaleString()} GB bandwidth`;

  return `${gbString}/month`;
}
